module.exports = __webpack_public_path__ + "ee171740e2f8452ad2c9e7b7e00d7816.svg";